import {MedPassCard} from './medpass_card/MedPassCard';

export {MedPassCard};
